module.exports = __webpack_public_path__ + "static/media/biometric-lock.d094dd59.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/biometric-lock.png
// module id = 1190
// module chunks = 0